import { atom } from "recoil";
export const recoveryPoints = atom({
  key: "recoveryPoints", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
